import { render, staticRenderFns } from "./PostingListItem.vue?vue&type=template&id=1cd073b8&"
import script from "./PostingListItem.vue?vue&type=script&lang=js&"
export * from "./PostingListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports